module.exports = "/_next/static/images/Interport-3d9b2a588eeb9051f3f2b4c95030e5d1.png";